import axios from '../../../axiosConfig';

export async function createDepreciationRate(data, config = {}) {
    return await axios.post(`/v1/depreciation-rate`, data, config);
}

export async function deleteDepreciationRate(clientId, config = {}) {
    return await axios.delete(`/v1/depreciation-rate/${clientId}`, config);
}

export async function updateDepreciationRate(data, config = {}) {
    return await axios.put(`/v1/depreciation-rate/${data.id}`, data, config);
}

const functions = { createDepreciationRate, deleteDepreciationRate, updateDepreciationRate }
export default functions
